import StepLoader from '@components/loaders/StepLoader'
import CautionIconSVG from '@media/svgs/CautionIconSVG'

const REQUIRED_PARAMS = ['token', 'gameCode']

const LaunchParamsNotice = ({ variant = 'loading', missingParams = [] }) => {
  if (variant === 'loading') {
    return (
      <div className="launch-params-notice-outer-container">
        <div className="launch-params-notice-inner-container">
          <div className="launch-params-notice-loader-container">
            <span className="notice-loading-letter">L</span>
            <span className="notice-loading-loader">
              <StepLoader />
            </span>
            <span className="notice-loading-letter">A</span>
            <span className="notice-loading-letter">D</span>
            <span className="notice-loading-letter">I</span>
            <span className="notice-loading-letter">N</span>
            <span className="notice-loading-letter">G.</span>
          </div>
        </div>
      </div>
    )
  }

  const params = REQUIRED_PARAMS.filter((param) => missingParams[param])

  return (
    <div className="launch-params-notice-outer-container">
      <div className="launch-params-notice-inner-container">
        <div className="launch-params-notice-missing-parmas-container">
          <div className="lpn-missing-params-outer-container">
            <div className="lpn-missing-params-inner-container">
              <div className="lpn-missing-params-inner-icon-container">
                <div className="lpn-missing-params-icon-shell">
                  <CautionIconSVG color="#f04545" size="26px" />
                </div>
              </div>
              <div className="lpn-missing-params-inner-title-container">
                Unable to launch the game
              </div>
              <div className="lpn-missing-params-inner-description-container">
                Some required parameters are missing, so the game can't start. Pass required params.
              </div>
              <div className="lpn-missing-params-inner-info-container">
                <div className="lpn-missing-params-info-title">
                  {' '}
                  Missing required parameter{params.length > 1 ? 's' : ''}
                </div>
                <div className="lpn-missing-params-info-chips-container">
                  {params.map((param) => (
                    <span key={param} className="lpn-param-chip">
                      {param}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LaunchParamsNotice
